import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { Input, FormFeedback, FormGroup, Label } from 'reactstrap';
import { firebase } from '../utils/firebase';
import Checkout from '../checkout';

class gift extends Component {
    constructor() {
        super()

        this.onHandleChange = this.onHandleChange.bind(this)
        this.submitProfile = this.submitProfile.bind(this)
        this.loginAnom = this.loginAnom.bind(this)
        this.s4 = this.s4.bind(this)
        this.guid = this.guid.bind(this)
        this.validateInputs = this.validateInputs.bind(this)
        this.setNumTags = this.setNumTags. bind(this)

        this.state = {
            email: '',
            deliveryType: 'emailDelivery',
            userPaid: false,
            validInputs: false,
            firstName:'',
            lastName:'',
            phoneNumberPrimary:'',
            ownerName:'',
            petName:'',
            line1:'',
            line2:'',
            city:'',
            state:'',
            zip:'',
            firstRun: true,
            shippingType:'slowShipping',
            shippingName: 'shippingName',
            deliveryEmail: '',
            standardShipping:0,
            expeditedShipping:795,
            amountSet: '',
            price: '',
            userId: 0,
            numberOfTags: 1,
        }
    }
   
    
    render() {
        const user = this.state.currentUser;
        return (
           <div>
            {
             this.state.userPaid ? "Thank you for gifting a VERFID tag!":
             <div className="sub50">
             <h3>Gift a Tag</h3>
             <Label onClick={() => alert('Gifting a smart tag is easy! After completing the ordering process, a unique gift code will be generated. This code can be redeemed at any time by the gift recipient to claim their new smart tag. \r\n\r\n   1. Enter your information. \r\n\r\n   2. Enter the Pet Owner’s Name(s) & Name(s) of the pet(s) who will be getting a new smart tag. \r\n\r\n   3. Choose the number of tags you’d like to order.\r\n  * Do your friends or family have more than one pet? Don’t leave anyone out! \r\n\r\n   4. Choose the delivery method. We can email the gift code or mail it to the recipient.\r\n  * Not quite ready for your gift to be sent? No problem. We can email or mail the code directly to you, so you can deliver the gift when the time is right! \r\n\r\nPlease contact us with any questions at customersupport@verfidpet.com \r\n\r\nNeed a custom order? Please contact us, and we’ll do our best to accommodate your request. ')} >(Click here to learn how it works)</Label>
             <br/>
             <h5>Your Information</h5>            
                    <div id="loginBlock">
                    <FormGroup> 
                        <Input type="email" name="email" maxLength="50" id="exampleEmail" placeholder="Email" onChange={this.onHandleChange} />
                        <Input type="text" name="firstName" id="firstname" placeholder="First Name" onChange={this.onHandleChange} />
                        <Input type="text" name="lastName" id="lastName" placeholder="Last Name" onChange={this.onHandleChange} />
                        <Input type="text" maxLength="10" minLength="10" pattern="[0-9]*" placeholder="Phone Number" name="phoneNumberPrimary" id="phoneNumberPrimary" onChange={this.onHandleChange}/>
                    </FormGroup>
             <br/>
             <h5>Gift Recipient Information</h5>     
                    <FormGroup> 
                        <Input type="text" name="ownerName" id="ownerName" placeholder="Owner Name(s)" onChange={this.onHandleChange} />
                        <Input type="text" name="petName" id="petName" placeholder="Pet Name(s)" onChange={this.onHandleChange} />
                        <br/>
            <h5>Number of Tags to Order</h5>    
                        <Input type="number" name="numberOfTags" id="numberOfTags" maxLength="2" max="10" min="0" placeholder="1" defaultValue={1} onChange={this.setNumTags}/>
             <br/>
             <h5>Gift Code Delivery Method</h5>    
             <Label onClick={() => alert('You can choose to deliver the gift code directly to yourself or directly to the recepient by email or regular mail.')}>What are my delivery options?</Label>
                        <Input type="select" name="deliveryType" onChange={this.onHandleChange}>
                            <option value='emailDelivery'>Email Delivery</option>
                            <option value='mailDelivery'>Mail Delivery</option>
                        </Input>
                    </FormGroup>
                    {this.state.deliveryType==='emailDelivery'? null:
                    <FormGroup>
                    <Input type="text" name="shippingName" id="shippingName" placeholder='Name To Ship To' onChange={this.onHandleChange} />
                    <Input type="text" name="line1" id="line1" placeholder='Street Address' onChange={this.onHandleChange} />
                    <Input type="text" name="line2" id="line2" placeholder="Apartment, Suite, Unit, etc." onChange={this.onHandleChange} />
                    <Input type="text" name="city" id="city" placeholder="City" onChange={this.onHandleChange} />
                    <Input type="text" name="state" id="state" placeholder="State/Province/Region" onChange={this.onHandleChange} />
                    <Input type="number" name="zip" id="zip" placeholder="Zip Code" onChange={this.onHandleChange} />
                    </FormGroup>
                    }
                    {this.state.deliveryType==='emailDelivery'? 
                    <div>
                    <FormGroup>
                    <Input type="text" name="shippingName" id="shippingName" placeholder='Recipient Name' onChange={this.onHandleChange} />
                    <Input type="deliveryEmail" name="deliveryEmail" maxLength="50" id="deliveryEmail" placeholder="Recipient Email Address" onChange={this.onHandleChange} />
                    </FormGroup>

                    </div>
                    :<div>
                    <h5>Shipping Type</h5>     
                    <Input type="select" name="shippingType" onChange={this.onHandleChange}>
                            <option value='slowShipping'>Standard- {this.state.standardShipping===0? "Included" : (this.state.standardShipping / 100).toFixed(2)} (5-7 days)</option>
                            <option value='expeditedShipping'>Expedited- {(this.state.expeditedShipping / 100).toFixed(2)} (1-3 days)</option>
                    </Input>
                    <br/>
                    </div>
                    }
                    {
                    this.state.amountSet===''?null:
                     <h5>Tag Price: ${(this.state.amountSet / 100).toFixed(2)}</h5>
                    }
                    {
                        this.state.validInputs?
                        <Checkout
                        amount={this.state.amountSet}
                        description={"VERFID Tag Gift Code"}
                        userId={this.state.userId}
                        onSuccess={()=>this.submitProfile()}
                        email={this.state.email}
                        />
                        : null}
                    </div>
                </div>
            }
            </div>
        )//return
    }

    onHandleChange(e) {
        var value = e.target.value;
        var name = e.target.name;
        var location = firebase.firestore().collection('gifts').doc('price');
    
        if(this.state.firstRun){
            this.loginAnom();

            location.get()
            .then(function (doc) {
                var priceSet = doc.data();
                return priceSet;
            }).then(priceSet=>{
                this.setState({amountSet: priceSet.price, price: priceSet.price, expeditedShipping:priceSet.expeditedShipping,standardShipping:priceSet.standardShipping})
            })
            .then(()=>
            this.setState({
                firstRun: false,
                userId: this.guid(),
              })
            )
        } //on first type, set everything up

        if(name==='shippingType'){
            var setPrice;
            if(value==="slowShipping"){
                setPrice=this.state.price*this.state.numberOfTags + this.state.standardShipping;
            }
            else{
                setPrice= this.state.price*this.state.numberOfTags + this.state.expeditedShipping;
            }
            this.setState({
                amountSet: setPrice,
              })
        }

      this.setState({
        [name]: value,
      })
      this.validateInputs();
    }

    loginAnom() {
        
        firebase.auth().signInAnonymously().catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
        }).then(()=>{
        })
      }

    submitProfile(){
        
        var db = firebase.firestore();
        var location = db.collection('gifts').doc(this.state.userId);
        var promoLocation = db.collection('promoCodes').doc(this.state.userId);
        //update firebase
        location.set(this.state).then(()=>{
        //now show that they paid
        this.setState({userPaid: true});
        })
        .then(()=>{
            promoLocation.set({price:0,maxUses:this.state.numberOfTags, text: "Thank you for claiming your smart tag! What an awesome gift!"})
        })
      }

      setNumTags(e) {
        var setPrice = 0;
        if(this.state.shippingType==="slowShipping" || this.state.deliveryType==="emailDelivery"){
            setPrice=this.state.price*e.target.value + this.state.standardShipping;
        }
        else{
            setPrice= this.state.price*e.target.value + this.state.expeditedShipping;
        }
        this.setState({ numberOfTags: parseInt(e.target.value, 10) ,  amountSet: setPrice})
      }

      s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
    
      guid() {
        return this.s4() + this.s4() + this.s4() + this.s4();
      }

      validateInputs() {
        var ValidInputs = true;

        if(this.state.email==='' || this.state.firstName==='' || this.state.lastName===''||this.state.phoneNumberPrimary===''||this.state.ownerName===''||this.state.petName===''){
            ValidInputs = false;
        }

        if(ValidInputs){
            this.setState({validInputs: true});           
        }
      }

}

export default gift


// WEBPACK FOOTER //
// ./src/components/gift.js